module.exports = __webpack_public_path__ + "static/media/1.dff02330.png";